<template>
  <div id="simulation" class="form container" :class="$mq">
    <h3>{{ $t("comparison.title") }}</h3>
    <p class="scenario container txt-left" v-if="economy < 0">{{ $t(`comparison.${scenario}`) }}</p>
    <div class="container inline top" v-if="$mq !== 'mobile'">
      <div class="compare">
        <Details
          :range="range"
          :rangeCompetitor="rangeCompetitor"
          v-if="showDetails"
          @close="showDetails = false"
        ></Details>
        <div class="economy inline" v-if="economy > 0">
          <div class="amount">
            <span class="bold">{{ economy | toInteger }} €</span>
            {{ $t('comparison.product.economy') }}
          </div>
        </div>
        <div class="product first">
          <div class="title inline">
            <img src="@/assets/logoMegaHeader.svg" />
          </div>
          <div class="price">
            <div class="inline center">
              <span class="amount">{{ range.amounts.annual | toCurrency }}</span>
              <span>
                {{ $t(`comparison.product.${amountType}`) }}
                <br />
                {{ $t("comparison.product.annualy") }}
              </span>
            </div>
            <div class="inline center">
              <span class="amount second">{{ range.amounts.monthly | toCurrency }}</span>
              <span>
                {{ $t(`comparison.product.${amountType}`) }}
                <br />
                {{ $t("comparison.product.monthly") }}
              </span>
            </div>
          </div>
          <button
            class="details"
            @click="showDetails = true"
          >{{ $t('comparison.product.showDetail') }}</button>
          <div class="energy elec" v-if="hasElec && elecProducts">
            <div class="product-name space-between inline">
              <SvgIcon icon="elec" fill></SvgIcon>
              <select
                class="product-select"
                v-model="megaElecProduct"
                @change="selectProduct(megaElecProduct)"
              >
                <option
                  v-for="product in elecProducts.mega"
                  :key="product.name"
                  v-bind:value="product"
                >{{ productName(product) }} {{$tc(`comparison.product.year`, product.duration)}}</option>
              </select>
              <SvgIcon :icon="`product-${range.name}`" fill :key="range.name"></SvgIcon>
            </div>
            <table class="product-price">
              <tr>
                <td>{{ $t('comparison.product.subscription') }}</td>
                <td>{{ megaElecProduct.subscription[priceEuro] | toCurrency }} {{ $t('unity.annual') }}</td>
              </tr>
              <tr v-if="megaElecProduct.subtotal.discount">
                <td>{{$t('comparison.product.discount')}}</td>
                <td>{{ megaElecProduct.subtotal.discount[priceEuro] | toCurrency }} {{ $t('unity.annual') }}</td>
              </tr>
              <tr v-for="meterType in elecMeterTypes" :key="meterType">
                <td>{{ $tc(meterType, elecMeterTypes.length) }}</td>
                <td>{{ megaElecProduct.energy[meterType][unitaryPriceEuro] * 100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
              </tr>
              <tr>
                <td>{{ $t('comparison.product.ecoTaxes') }}</td>
                <td>{{ megaElecProduct.subtotal.renewable[unitaryPriceEuro] * 100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
              </tr>
            </table>
          </div>
          <div class="energy gas" v-if="hasGas && gasProducts">
            <div class="product-name space-between inline">
              <SvgIcon icon="gas" fill></SvgIcon>
              <select
                class="product-select"
                v-model="megaGasProduct"
                @change="selectProduct(megaGasProduct)"
              >
                <option
                  v-for="product in gasProducts.mega"
                  :key="product.name"
                  v-bind:value="product"
                >{{ productName(product) }} {{$tc(`comparison.product.year`, product.duration)}}</option>
              </select>
              <SvgIcon :icon="`product-${range.name}`" fill :key="range.name"></SvgIcon>
            </div>
            <table class="product-price">
              <tr>
                <td>{{ $t('comparison.product.subscription') }}</td>
                <td>{{ megaGasProduct.subscription[priceEuro] | toCurrency }} {{ $t('unity.annual') }}</td>
              </tr>
              <tr v-if="megaGasProduct.subtotal.discount">
                <td>{{$t('comparison.product.discount')}}</td>
                <td>{{ megaGasProduct.subtotal.discount[priceEuro] | toCurrency }} {{ $t('unity.annual') }}</td>
              </tr>
              <tr>
                <td>{{ $t('comparison.product.consumption') }}</td>
                <td>{{ megaGasProduct.energy.day[unitaryPriceEuro] *100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
              </tr>
            </table>
          </div>
          <div class="become">
            <a :href="become" class="button">{{ $t('become') }}</a>
          </div>
          <Services :range="range"></Services>
        </div>
      </div>

      <div class="compare">
        <div class="product second">
          <div class="title">
            <h2>{{ $t('comparison.product.actualContract') }}</h2>
          </div>
          <div class="price">
            <div class="inline center">
              <span class="amount">{{ rangeCompetitor.amounts.annual | toCurrency }}</span>
              <span>
                {{ $t(`comparison.product.${amountType}`) }}
                <br />
                {{ $t("comparison.product.annualy") }}
              </span>
            </div>
            <div class="inline center">
              <span class="amount second">{{ rangeCompetitor.amounts.monthly | toCurrency }}</span>
              <span>
                {{ $t(`comparison.product.${amountType}`) }}
                <br />
                {{ $t("comparison.product.monthly") }}
              </span>
            </div>
          </div>
          <button
            class="details grey"
            @click="showDetails = true"
          >{{ $t('comparison.product.showDetail') }}</button>
          <div class="elec energy" v-if="hasElec && competitorElecProduct">
            <div class="product-name space-between inline">
              <SvgIcon icon="elec" fill></SvgIcon>
              <select
                class="product-select"
                v-model="competitorElecProduct"
                @change="selectProduct(competitorElecProduct)"
              >
                <option
                  v-for="product in elecProducts.competitor"
                  :key="product.name"
                  v-bind:value="product"
                >{{ product[productNameTrad] }}</option>
              </select>
            </div>
            <table class="product-price">
              <tr>
                <td>{{ $t('comparison.product.subscription') }}</td>
                <td
                  v-if="competitorElecProduct.id !== 'myElec'"
                >{{ competitorElecProduct.subscription.priceEuroVAT | toCurrency }} {{ $t('unity.annual') }}</td>
                <td v-else>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="myprice"
                    v-bind:value="competitorElecProduct.subscription.priceEuroVAT / tva | toInputCurrency"
                    @blur="competitorElecProduct.subscription.priceEuroVAT = validate($event.target.value)"
                  />
                  {{ $t('unity.annual') }}
                </td>
              </tr>
              <tr v-for="meterType in elecMeterTypes" :key="meterType">
                <td>{{ $tc(meterType, elecMeterTypes.length) }}</td>
                <td
                  v-if="competitorElecProduct.id !== 'myElec'"
                >{{ competitorElecProduct.energy[meterType].unitaryPriceEuroVAT * 100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
                <td v-else>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="myprice"
                    v-bind:value="competitorElecProduct.energy[meterType].unitaryPriceEuroVAT * 100 / tva | toInputCurrency"
                    @blur="competitorElecProduct.energy[meterType].unitaryPriceEuroVAT = validateConsumption($event.target.value)"
                  />
                  {{ $t('unity.centKWh') }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('comparison.product.ecoTaxes') }}</td>
                <td
                  v-if="competitorElecProduct.id !== 'myElec'"
                >{{ competitorElecProduct.subtotal.renewable.unitaryPriceEuroVAT * 100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
                <td v-else>
                  <input
                    type="number"
                    step="0.01"
                    class="myprice"
                    v-bind:value="competitorElecProduct.subtotal.renewable.unitaryPriceEuroVAT * 100 / tva | toInputCurrency"
                    @blur="competitorElecProduct.subtotal.renewable.unitaryPriceEuroVAT = validateConsumption($event.target.value)"
                  />
                  {{ $t('unity.centKWh') }}
                </td>
              </tr>
            </table>
          </div>
          <div class="gas energy" v-if="hasGas && competitorGasProduct">
            <div class="product-name space-between inline">
              <SvgIcon icon="gas" fill></SvgIcon>
              <select
                class="product-select"
                v-model="competitorGasProduct"
                @change="selectProduct(competitorGasProduct)"
              >
                <option
                  v-for="product in gasProducts.competitor"
                  :key="product.name"
                  v-bind:value="product"
                >{{ product[productNameTrad] }}</option>
              </select>
            </div>
            <table class="product-price">
              <tr>
                <td>{{ $t('comparison.product.subscription') }}</td>
                <td
                  v-if="competitorGasProduct.id !== 'myGas'"
                >{{ competitorGasProduct.subscription.priceEuroVAT | toCurrency }} €/an</td>
                <td v-else>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="myprice"
                    v-bind:value="competitorGasProduct.subscription.priceEuroVAT / tva | toInputCurrency"
                    @blur="competitorGasProduct.subscription.priceEuroVAT = validate($event.target.value)"
                  />
                  {{ $t('unity.annual') }}
                </td>
              </tr>
              <tr>
                <td>{{ $t('comparison.product.consumption') }}</td>
                <td
                  v-if="competitorGasProduct.id !== 'myGas'"
                >{{ competitorGasProduct.energy.exclusiveDay.unitaryPriceEuroVAT * 100 | toCurrency }} {{ $t('unity.centKWh') }}</td>
                <td v-else>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="myprice"
                    v-bind:value="competitorGasProduct.energy.exclusiveDay.unitaryPriceEuroVAT * 100 / tva | toInputCurrency"
                    @blur="competitorGasProduct.energy.exclusiveDay.unitaryPriceEuroVAT = validateConsumption($event.target.value)"
                  />
                  {{ $t('unity.centKWh') }}
                </td>
              </tr>
            </table>
          </div>
          <div class="become grey">
            <a :href="become" class="button">
              <span v-if="$i18n.locale === 'nl'">{{ providerName }}</span>
              {{ $t('comparison.product.quit') }}
              <span
                v-if="$i18n.locale === 'fr'"
              >{{ providerName }}</span>
            </a>
          </div>
          <Services :range="rangeCompetitor"></Services>
        </div>
      </div>
    </div>
    <ComparisonMobile
      v-if="$mq ==='mobile'"
      :range="range"
      :rangeCompetitor="rangeCompetitor"
      @selectProduct="selectProduct"
    ></ComparisonMobile>
    <Informations v-if="$mq ==='desktop'"></Informations>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ComparisonMobile from "./comparison/mobile/Comparison";
import Details from "./comparison/Details";
import Services from "./components/Services";
import Informations from "./components/Informations";

export default {
  name: "comparison",
  data() {
    return {
      showDetails: false
    };
  },
  computed: {
    ...mapState("comparison", ["elecProducts", "gasProducts"]),
    ...mapGetters("comparison", ["amount", "total"]),
    ...mapGetters("consumption", ["elecMeterTypes"]),
    ...mapState("contact", ["isPro"]),
    ...mapState("calculation", [
      "providerElec",
      "providerGas",
      "providersElec",
      "providersGas"
    ]),
    ...mapState("energy", ["type"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    megaElecProduct: {
      get() {
        return this.$store.state.comparison.megaElecProduct;
      },
      set(value) {
        this.$store.commit("comparison/setMegaElecProduct", value);
      }
    },
    megaGasProduct: {
      get() {
        return this.$store.state.comparison.megaGasProduct;
      },
      set(value) {
        this.$store.commit("comparison/setMegaGasProduct", value);
      }
    },
    competitorElecProduct: {
      get() {
        return this.$store.state.comparison.competitorElecProduct;
      },
      set(value) {
        this.$store.commit("comparison/setCompetitorElecProduct", value);
      }
    },
    competitorGasProduct: {
      get() {
        return this.$store.state.comparison.competitorGasProduct;
      },
      set(value) {
        this.$store.commit("comparison/setCompetitorGasProduct", value);
      }
    },
    productNameTrad() {
      return this.$i18n.locale === "fr" ? "labelFr" : "labelNl";
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    priceEuro() {
      return this.isPro ? "priceEuro" : "priceEuroVAT";
    },
    unitaryPriceEuro() {
      return this.isPro ? "unitaryPriceEuro" : "unitaryPriceEuroVAT";
    },
    providerName() {
      let providerName = "";

      if (
        (this.providersElec && this.providersElec.length) ||
        (this.providersGas && this.providersGas.length)
      ) {
        switch (this.type) {
          case "elec":
            providerName = this.providersElec.find(
              provider => provider.id === this.providerElec
            ).name;
            break;
          case "gas":
            providerName = this.providersGas.find(
              provider => provider.id === this.providerGas
            ).name;
            break;
          case "both":
            if (this.providerElec === this.providerGas)
              providerName = this.providersElec.find(
                provider => provider.id === this.providerElec
              ).name;
            break;
        }
      }

      return providerName;
    },
    range() {
      let range = {
        type: "mega",
        amounts: {
          annual: 0
        }
      };

      if (this.hasElec && this.megaElecProduct) {
        range["name"] = this.megaElecProduct.range;
        range["electricity"] = this.megaElecProduct;
        range.amounts["electricity"] = {
          energy: range.electricity.subtotal.energy[this.priceEuro],
          renewable: range.electricity.subtotal.renewable[this.priceEuro],
          taxes:
            range.electricity.subtotal.taxes[this.priceEuro] +
            range.electricity.subtotal.taxesVAT[this.priceEuro],
          transport:
            range.electricity.subtotal.transportAndDistribution[this.priceEuro],
          total: range.electricity.total[this.priceEuro]
        };
      }

      if (this.hasGas && this.megaGasProduct) {
        range["name"] = this.megaGasProduct.range;
        range["gas"] = this.megaGasProduct;
        range.amounts["gas"] = {
          energy: range.gas.subtotal.energy[this.priceEuro],
          taxes:
            range.gas.subtotal.taxes[this.priceEuro] +
            range.gas.subtotal.taxesVAT[this.priceEuro],
          transport:
            range.gas.subtotal.transportAndDistribution[this.priceEuro],
          total: range.gas.total[this.priceEuro]
        };
      }

      if (this.hasElec && this.megaElecProduct)
        range.amounts.annual += range.amounts.electricity.total;
      if (this.hasGas && this.megaGasProduct)
        range.amounts.annual += range.amounts.gas.total;
      range.amounts["monthly"] = range.amounts.annual / 12;

      return range;
    },
    rangeCompetitor() {
      let range = {
        type: "competitor",
        amounts: {
          annual: 0
        }
      };

      if (this.hasElec && this.competitorElecProduct) {
        range["electricity"] = this.competitorElecProduct;
        let elecQuantity = 0;
        let elecEnergyAmount = 0;
        let elecRenewableAmount = 0;
        Object.keys(range.electricity.energy).forEach(key => {
          elecQuantity += range.electricity.energy[key].quantity;

          elecEnergyAmount +=
            parseFloat(range.electricity.energy[key].unitaryPriceEuroVAT) *
            range.electricity.energy[key].quantity;

          elecRenewableAmount +=
            parseFloat(
              range.electricity.subtotal.renewable.unitaryPriceEuroVAT
            ) * range.electricity.energy[key].quantity;
        });
        elecEnergyAmount += parseFloat(
          range.electricity.subscription.priceEuroVAT
        );
        let elecTaxes = range.electricity.subtotal.taxes.priceEuroVAT;
        let elecTransport =
          range.electricity.subtotal.transportAndDistribution.priceEuroVAT;

        range.amounts["electricity"] = {
          energy: elecEnergyAmount,
          quantity: elecQuantity,
          renewable: elecRenewableAmount,
          taxes: elecTaxes,
          transport: elecTransport,
          transport2: elecTransport,
          total:
            elecEnergyAmount + elecRenewableAmount + elecTaxes + elecTransport
        };
      }

      if (this.hasGas && this.competitorGasProduct) {
        range["gas"] = this.competitorGasProduct;

        let gasEnergyAmount =
          parseFloat(range.gas.energy.exclusiveDay.unitaryPriceEuroVAT) *
            range.gas.energy.exclusiveDay.quantity +
          parseFloat(range.gas.subscription.priceEuroVAT);
        let gasQuantity = range.gas.energy.exclusiveDay.quantity;

        let gasTaxes = range.gas.subtotal.taxes.priceEuroVAT;
        let gasTransport =
          range.gas.subtotal.transportAndDistribution.priceEuroVAT;

        range.amounts["gas"] = {
          energy: gasEnergyAmount,
          quantity: gasQuantity,
          taxes: gasTaxes,
          transport: gasTransport,
          total: gasEnergyAmount + gasTaxes + gasTransport
        };
      }

      if (this.hasElec && this.competitorElecProduct)
        range.amounts.annual += range.amounts.electricity.total;
      if (this.hasGas && this.competitorGasProduct)
        range.amounts.annual += range.amounts.gas.total;
      range.amounts["monthly"] = range.amounts.annual / 12;

      return range;
    },
    economy() {
      let economy =
        this.rangeCompetitor.amounts.annual - this.range.amounts.annual;

      let economyText = "";

      if (economy > 0) {
        economyText =
          this.$i18n.locale === "fr"
            ? ` et gagnez ${economy.toFixed(
                0
              )}€ par an ! Ça en fait des heures d'électricité ..`
            : ` in en win € ${economy.toFixed(
                0
              )} per jaar! Dat zijn heel wat uren elektriciteit..`;
      }
      this.$store.commit("comparison/setEconomyText", economyText);
      return economy;
    },
    scenario() {
      return (this.competitorElecProduct &&
        this.competitorElecProduct.id !== "myElec") ||
        (this.competitorGasProduct && this.competitorGasProduct.id !== "myGas")
        ? "scenario1"
        : "scenario2";
    },
    tva() {
      return this.isPro ? 1 : 1.21;
    },
    become() {
      return this.$store.getters["middleware/become"](this.range);
    }
  },
  methods: {
    validate(value) {
      this.$store.dispatch("comparison/save", "priceChanged");
      this.$store.commit(
        "comparison/setMyElecProduct",
        this.competitorElecProduct
      );
      this.$store.commit(
        "comparison/setMyGasProduct",
        this.competitorGasProduct
      );
      return value < 0 ? 0 : parseFloat(value) * this.tva;
    },
    validateConsumption(value) {
      this.$store.dispatch("comparison/save", "priceChanged");
      this.$store.commit(
        "comparison/setMyElecProduct",
        this.competitorElecProduct
      );
      this.$store.commit(
        "comparison/setMyGasProduct",
        this.competitorGasProduct
      );
      return value < 0 ? 0 : (value = (value / 100) * this.tva);
    },
    productName(product) {
      return this.$store.getters["comparison/productName"](
        product
      ).toUpperCase();
    },
    selectProduct(product) {
      let peerProduct = this.$store.getters["comparison/findPeer"](product);

      if (peerProduct) {
        if (peerProduct.range !== undefined) {
          // Mega
          if (peerProduct.energyType === "electricity") {
            this.megaElecProduct = peerProduct;
          } else {
            this.megaGasProduct = peerProduct;
          }
        } else {
          // Competitor
          if (peerProduct.energyType === "electricity") {
            this.competitorElecProduct = peerProduct;
          } else {
            this.competitorGasProduct = peerProduct;
          }
        }
      }

      if (product.range === undefined) {
        this.$store.dispatch("comparison/setDefaultMegaProduct");
      }

      if (this.rangeCompetitor.electricity && this.range.electricity) {
        let savings =
          this.rangeCompetitor.amounts.electricity.total -
          this.range.amounts.electricity.total;
        this.$store.commit("comparison/setSavingsElec", savings);
      }

      if (this.rangeCompetitor.gas && this.range.gas) {
        let savings =
          this.rangeCompetitor.amounts.gas.total - this.range.amounts.gas.total;
        this.$store.commit("comparison/setSavingsGas", savings);
      }

      this.$store.dispatch("comparison/save", "productChanged");
    }
  },
  watch: {
    competitorElecProduct: function(oldValue, newValue) {
      if (oldValue.id !== newValue.id) this.selectProduct(this.megaElecProduct);
    }
  },
  filters: {
    toCurrency: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
    toInputCurrency: function(value) {
      return parseFloat(value).toFixed(2);
    },
    toInteger: function(value) {
      return parseFloat(value).toFixed(0);
    }
  },
  created() {
    if (this.rangeCompetitor.electricity && this.range.electricity) {
      let savings =
        this.rangeCompetitor.amounts.electricity.total -
        this.range.amounts.electricity.total;
      this.$store.commit("comparison/setSavingsElec", savings);
    }

    if (this.rangeCompetitor.gas && this.range.gas) {
      let savings =
        this.rangeCompetitor.amounts.gas.total - this.range.amounts.gas.total;
      this.$store.commit("comparison/setSavingsGas", savings);
    }

    this.$store.dispatch("comparison/save");

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "cookie-acceptation_true",
      "cookie-acceptation": "true"
    });
  },
  components: {
    ComparisonMobile,
    Details,
    Services,
    Informations
  }
};
</script>

<style lang="scss" scoped>
.scenario {
  padding: 0 15px;
  font-size: 0.8rem;
}

.compare {
  width: 35%;
  min-width: 300px;
  position: relative;

  .economy {
    position: absolute;
    width: 160px;
    height: 160px;
    z-index: 10;
    top: -10px;
    right: -70px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../assets/icons/icon-economy.svg") left;

    .amount {
      width: 100px;
      font-size: 0.8rem;
      color: #000;

      .bold {
        font-size: 1.5rem;
        font-weight: 500;
      }
    }
    .icon {
      font-size: 10rem;
    }
  }

  &:first-child {
    margin-right: 50px;
  }

  .product {
    box-shadow: 5px 10px 10px #4d545a18;
    border-top: 15px solid #fdcb47;
    border-radius: 30px;
    padding: 20px 0;
    margin-top: 30px;
    background: white;

    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 70px;
      font-size: 1rem;
      font-weight: 700;

      img {
        height: 55%;
      }
    }

    .details {
      padding: 5px 10px;
      margin: 10px;
      border: 0;
      background: none;
      color: #fdcb47;
      border: 2px solid #fdcb47;

      &.grey {
        color: #7a828c;
        border: 2px solid #7a828c;
      }
    }

    .price {
      color: #231f20;
      font-size: 0.6rem;
      padding: 10px 0;

      .amount {
        font-size: 1.8rem;
        font-weight: 500;

        &.second {
          font-size: 1.2rem;
          font-weight: normal;
        }
      }
    }

    .energy {
      color: #231f20;
      margin-bottom: 20px;

      .product-name {
        font-size: 1.5rem;
        margin: 0 5%;
        border: 1px solid #f7f7f7;

        select {
          width: 100%;
          padding: 5px;
          border: 0;
          margin-left: 0px;
          flex: 1;
        }
      }

      .product-price {
        margin-top: 20px;
        text-align: left;
        font-size: 0.8rem;
        width: 100%;
        border: 0;
        border-collapse: collapse;

        tr {
          &:nth-child(odd) {
            background: #f7f7f7;
          }

          td {
            padding: 7px 10px;

            .myprice {
              text-align: right;
              border: 1px solid #eee;
              width: 60px;
            }
          }
        }
      }
    }

    .detail {
      font-size: 0.8rem;
      padding: 20px;
    }

    .become {
      .button {
        font-weight: 600;
        margin: 0;
        padding: 10px 20px;
        font-size: 1.3rem;
        border: 0;
        background: #fdcb47;
        border-radius: 50px;
        box-shadow: 3px 6px 8px #fdcb475e;
      }

      &.grey {
        .button {
          color: #4d545a;
          background: #eee;
          box-shadow: 3px 6px 8px #aaaaaa5e;
        }
      }
    }

    .services {
      padding: 20px;
      margin-top: 20px;
      list-style: none;

      li {
        color: #4d545a;
        font-size: 0.9rem;
        padding: 5px;
        text-align: left;

        .icon {
          margin-right: 10px;
          color: #f1911f;
          font-size: 1.2rem;
        }
      }
    }

    &.first {
      z-index: 2;
      box-shadow: rgba(77, 4, 4, 0.158) 5px 10px 10px;

      .price {
        background: #fdcb47;
      }
    }

    &.second {
      border-top: 15px solid #7a828c;

      .title {
        .icon {
          color: #7a828c;
        }
      }

      .price {
        color: white;
        background: #7a828c;
      }
    }
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Comparison.vue